import { render, staticRenderFns } from "./modalCreateReadDBInstance.vue?vue&type=template&id=5881eceb&"
import script from "./modalCreateReadDBInstance.vue?vue&type=script&lang=js&"
export * from "./modalCreateReadDBInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports